import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { BlogTag } from '@/typings/model';
import { colors } from '@/constants/theme';
import Link from '@/components/Link';

function TagLink({ tag, urlAlias }: BlogTag) {
  const parentRoute = useRouter().asPath.split('/')[1];

  return (
    <Component to={`/${parentRoute}?tag=${urlAlias}`}>
      <Label>{tag}</Label>
    </Component>
  );
}

export default TagLink;

const Component = styled(Link)`
  position: relative;
  margin: 5px 5px 5px 0;
  padding: 5px 26px;
  background: ${colors.gray400};
  border-radius: 15px;
  transition: 0.3s;

  &:hover {
    background: ${colors.gray500};
  }
`;

const Label = styled.span`
  font-size: 14px;
  line-height: 20px;
  transition: 0.3s;
  user-select: none;
`;
